import { Button, Icon, cn } from "@nexus/ui";
import { Link } from "@tanstack/react-router";
import type { MouseEvent } from "react";

import { SCRIPT_REVIEW_ROUTE } from "../lib/preflight-report-path";

interface ScriptReviewActionProps {
  scriptReviewId: string | null;
  preflightUrl: string | null;
  label: string;
  ariaLabel: string;
  variant?: "default" | "outline" | "ghost";
  size?: "default" | "sm";
  compact?: boolean;
  className?: string;
}

export function ScriptReviewAction({
  scriptReviewId,
  preflightUrl,
  label,
  ariaLabel,
  variant = "default",
  size = "default",
  compact = false,
  className,
}: ScriptReviewActionProps) {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.stopPropagation();
  };

  const content = (
    <>
      <Icon name="play" size="sm" color="inherit" aria-hidden />
      {label}
    </>
  );

  if (scriptReviewId) {
    return (
      <Button
        asChild
        variant={variant}
        size={size}
        className={cn(!compact && "min-h-11", className)}
      >
        <Link
          to={SCRIPT_REVIEW_ROUTE}
          params={{ reviewId: scriptReviewId }}
          target="_blank"
          rel="noreferrer"
          aria-label={ariaLabel}
          onClick={handleClick}
        >
          {content}
        </Link>
      </Button>
    );
  }

  if (!preflightUrl) return null;

  return (
    <Button
      asChild
      variant={variant}
      size={size}
      className={cn(!compact && "min-h-11", className)}
    >
      <a
        href={preflightUrl}
        target="_blank"
        rel="noreferrer"
        aria-label={ariaLabel}
        onClick={handleClick}
      >
        {content}
      </a>
    </Button>
  );
}
